import { apiURLNew, callAPI } from 'api/main';

interface IGetTermsOfUseProps {
  token: string;
  lang: string;
}

export default async ({ token, lang }: IGetTermsOfUseProps): Promise<ITerms | null> => {
  try {
    const res = await callAPI({
      url: `${apiURLNew}/terms/v1/`,
      method: 'GET',
      forcedToken: token,
      isLegacy: false,
      params: {
        lang: lang.toLowerCase(),
      },
    });

    const { data } = res.request;

    if (data) {
      const privacyData = data.find((item: any) => item.type === 'privacy');
      const termsData = data.find((item: any) => item.type === 'term');

      const privacy = privacyData?.term_content[0].Body ?? '';
      const privacyId = Number(privacyData?.id ?? -1);
      const latestPrivacyVersion = Number(privacyData?.term_content[0].Version ?? -1);

      const terms = termsData.term_content[0].Body ?? '';
      const termId = Number(termsData.id ?? -1);
      const latestTermVersion = Number(termsData.term_content[0].Version ?? -1);

      return {
        privacyId,
        latestPrivacyVersion,
        privacy,

        termId,
        latestTermVersion,
        terms,
      };
    }

    return null;
  } catch (ex) {
    return null;
  }
};
